import type {
    DirtyScope,
    EntityPatchOperation,
    HistoryEntitySnapshot,
    SnapshotScope,
} from '../../../types/history/HistoryTypes';

export type {
    CadTransaction,
    CadTransactionStatus,
    ChangeSet,
    DirtyScope,
    EntityPatch,
    EntityPatchMetadata,
    EntityPatchOperation,
    HistoryApplyDirection,
    HistoryEntitySnapshot,
    SnapshotScope,
} from '../../../types/history/HistoryTypes';

/**
 * 创建存在实体快照。
 *
 * @param data 主状态快照数据。
 * @returns 存在实体快照。
 */
export function createExistingHistorySnapshot<TData>(data: TData): HistoryEntitySnapshot<TData> {
    return {
        exists: true,
        data,
    };
}

/**
 * 创建缺失实体快照。
 *
 * @returns 缺失实体快照。
 */
export function createMissingHistorySnapshot(): HistoryEntitySnapshot<never> {
    return {
        exists: false,
    };
}

/**
 * 根据 before / after 快照推导补丁操作。
 *
 * @param before 变更前快照。
 * @param after 变更后快照。
 * @returns 补丁操作类型。
 */
export function resolveEntityPatchOperation(
    before: HistoryEntitySnapshot,
    after: HistoryEntitySnapshot,
): EntityPatchOperation {
    if (!before.exists && after.exists) {
        return 'create';
    }

    if (before.exists && !after.exists) {
        return 'delete';
    }

    if (before.exists && after.exists) {
        return 'update';
    }

    return 'noop';
}

/**
 * 创建空 dirtyScope。
 *
 * @returns 空 dirtyScope。
 */
export function createEmptyDirtyScope(): DirtyScope {
    return {
        entityIds: [],
        sketchIds: [],
        featureIds: [],
        componentInstanceIds: [],
        assemblyIds: [],
        topologyObjectIds: [],
        renderObjectIds: [],
    };
}

/**
 * 创建空 snapshotScope。
 *
 * @returns 空 snapshotScope。
 */
export function createEmptySnapshotScope(): SnapshotScope {
    return {
        entityIds: [],
        solverIslandIds: [],
    };
}
